export default __webpack_public_path__ + "static/media/(22).99b0e2a8.jpg";